// Easing
var easeInOutQuad = function (t, b, c, d) {
  t /= d/2;
  if (t < 1) {
    return c/2*t*t + b
  }
  t--;
  return -c/2 * (t*(t-2) - 1) + b;
};

var moveToPosition = function(amount) {
  document.documentElement.scrollTop = amount;
  document.body.parentNode.scrollTop = amount;
  document.body.scrollTop = amount;
};

module.exports = function(scrollToPosition, config, callback) {

  config = config || {};

  var positionStart = document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop,
      timeStart = new Date().getTime(),
      scrollDuration = config.duration || 500,
      scrollOffset = config.offset || 0,
      positionTo = scrollToPosition;

  // If position is a {jQuery|Node}Element - get offsetTop position
  if (positionTo instanceof $)
    positionTo = positionTo.offset().top;
  if (positionTo instanceof HTMLElement)
    positionTo = positionTo.getBoundingClientRect().top - document.body.getBoundingClientRect().top;

  // Add offset to the position
  if (config.offset)
    positionTo = positionTo + config.offset;

  var animateScroll = function() {
    
    var positionDelta = positionTo - positionStart;
    var timeElapsed = (new Date().getTime() - timeStart);
    var positionNew = easeInOutQuad(timeElapsed, positionStart, positionDelta, scrollDuration);
    
    moveToPosition(positionNew);

    if (timeElapsed < scrollDuration)
      window.requestAnimationFrame(animateScroll);
    else
      if (callback && typeof(callback) === 'function')
        callback();

  };

  if (window.requestAnimationFrame)
    animateScroll();
  else
    moveToPosition(positionTo);

};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-ui-scroll.js